import { combineReducers } from "redux"
import defaultReducer from "@kiwicom/frontend-common/services/index"

import additionalServices from "../scenes/AccountBooking/components/Booking/services/additionalServices/index"
import alternativeFlights from "../scenes/AccountBooking/components/Booking/scenes/BookingJourneyChange/services/AlternativeFlightsDuck"
import booking from "../scenes/AccountBooking/components/Booking/services"
import bookingInsurance from "../scenes/AccountBooking/components/Booking/services/bookingInsurance/index"
import changeFlights from "../scenes/AccountBooking/components/Booking/services/changeFlights/index"
import plainSearchForm from "../scenes/AccountBooking/components/Booking/scenes/BookingJourneyChange/services/PlainSearchFormDuck"
import passengerEdit from "../scenes/AccountBooking/components/Booking/scenes/BookingPassengerEdit/services/PassengerEditDuck"
import ancillaries from "../scenes/AccountBooking/components/Booking/scenes/BookingAncillary/services/BookingAncillaryDuck"
import fareType from "../scenes/AccountBooking/components/Booking/services/fareType/index"
import servicePackage from "../scenes/AccountBooking/components/Booking/scenes/ServicePackage/services/servicePackageDuck"
import bookingLocked from "../scenes/AccountBooking/components/BookingLocked/services/bookingLockedDuck"
import emergencyBanners from "../scenes/AccountBooking/components/Booking/services/emergencyBanners/reducer"

export const mmbReducers = {
  additionalServices,
  alternativeFlights,
  booking,
  bookingInsurance,
  changeFlights,
  passengerEdit,
  plainSearchForm,
  ancillaries,
  fareType,
  servicePackage,
  bookingLocked,
  emergencyBanners,
}
const mmbReducer = combineReducers({ ...defaultReducer, ...mmbReducers })

export default mmbReducer
